import React, { useState, useEffect } from 'react';
import { Camera, Map, DollarSign, Settings, Lightbulb, Menu, X } from 'lucide-react';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50); // Add background after scrolling 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const scrollTo = e.currentTarget.getAttribute('data-scroll-to');
    if (scrollTo) {
      const targetElement = document.getElementById(scrollTo);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    e.preventDefault();
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo-section">
          <h1 className="title">The Town</h1>
          <p className="subtitle">Create Together Project</p>
        </div>
        
        <button 
          className="hamburger-btn"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <nav className={`navigation ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <button data-scroll-to="gallery" className="nav-link" onClick={handleNavClick}>
            <Camera size={18} />
            Gallery
          </button>
          <button data-scroll-to="map" className="nav-link" onClick={handleNavClick}>
            <Map size={18} />
            Map
          </button>
          <button data-scroll-to="pricing" className="nav-link" onClick={handleNavClick}>
            <DollarSign size={18} />
            Pricing
          </button>
          <button data-scroll-to="services" className="nav-link" onClick={handleNavClick}>
            <Settings size={18} />
            Services
          </button>
          <button data-scroll-to="ideas" className="nav-link" onClick={handleNavClick}>
            <Lightbulb size={18} />
            Ideas
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header; 